<div class="msin-background"></div>

<div>
	<mat-card appearance="outlined" class="account-request-page">
		<mat-card-header>
			<mat-card-title>
				<a routerLink="/login">
					<img class="login-logo" alt="MSIN Logo"
						src="../../../../assets/images/MSIN-Logo_Color-White-Text.png" />
				</a>
			</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<div class="row">
				<div class="col-lg-9">
					<mat-card appearance="outlined">
						<div>
							<mat-card-header>
								<mat-card-title>Request an Account</mat-card-title>
							</mat-card-header>
							<mat-card-content>
								<mat-stepper orientation="vertical" [linear]="true" #stepper>
									<mat-step [stepControl]="personalInfoForm">
										<form [formGroup]="personalInfoForm">
											<ng-template matStepLabel>
												Personal Information
											</ng-template>

											<div class="row">
												<mat-form-field class="col-lg-8">
													<mat-label>
														First Name
													</mat-label>
													<input matInput type="string" placeholder="First Name"
														formControlName="firstName" />
												</mat-form-field>

												<mat-form-field class="col-lg-4">
													<mat-label>M.I.</mat-label>
													<input matInput type="string" placeholder="Middle Initial"
														maxlength="1" formControlName="middleInitial" />
												</mat-form-field>
											</div>
											<div class="row">
												<mat-form-field class="col-lg-8">
													<mat-label>
														Last Name
													</mat-label>
													<input matInput type="string" placeholder="Last Name"
														formControlName="lastName" />
												</mat-form-field>

												<mat-form-field class="col-lg-4">
													<mat-label>
														Suffix
													</mat-label>
													<mat-select formControlName="suffix">
														<mat-option>No Suffix</mat-option>
														<mat-option *ngFor="let suffix of suffixes" [value]="suffix">
															{{ suffix }}
														</mat-option>
													</mat-select>
												</mat-form-field>
											</div>
											<div class="row">
												<mat-form-field class="col">
													<mat-label>
														Work Title
													</mat-label>
													<input matInput type="string" placeholder="Work Title"
														formControlName="workTitle" />
												</mat-form-field>
											</div>

											<div class="row">
												<input-email class="col-lg-6" [form]="personalInfoForm"
													[controlName]="'workEmail'" [matLabel]="'Work Email'"
													[placeholder]="'Work Email'" [(emailToConfirm)]="emailToConfirm">
												</input-email>
												<input-email-confirm class="col-lg-6" [form]="personalInfoForm"
													[controlName]="'confirmWorkEmail'" [targetControlName]="'workEmail'"
													[matLabel]="'Confirm Work Email'"
													[placeholder]="'Confirm Work Email'"
													[emailToConfirm]="emailToConfirm"></input-email-confirm>
											</div>

											<div class="row">
												<div class="col-lg-6">
												</div>
												<div class="col-lg-6">
													<mat-card>
														<button mat-raised-button (click)="goNextPersonalInfo(stepper)"
															color="primary" [disabled]="!checkPersonalInfoValid()">
															Next
														</button>
													</mat-card>
												</div>
											</div>
										</form>
									</mat-step>
									<mat-step [stepControl]="locationForm">
										<form [formGroup]="locationForm">
											<ng-template matStepLabel>
												Location Information
											</ng-template>

											<div class="row">
												<mat-form-field class="col-lg-6">
													<mat-label>
														Work Address 1
													</mat-label>
													<input matInput type="string" placeholder="Work Address 1"
														formControlName="workAddress1" />
												</mat-form-field>

												<mat-form-field class="col-lg-6">
													<mat-label>
														Work Address 2
													</mat-label>
													<input matInput type="string" placeholder="Work Address 2"
														formControlName="workAddress2" />
												</mat-form-field>
											</div>
											<div class="row">
												<input-city-autocomplete class="col-lg-4" [id]="'City'" [name]="'City'"
													[label]="'City'" [placeholder]="'City'" [(selectedCity)]="city"
													[(state)]="state" [required]="true"></input-city-autocomplete>

												<input-state-autocomplete class="col-lg-4" [id]="'State'"
													[name]="'State'" [label]="'State'" [placeholder]="'State'"
													[(selectedState)]="state"
													[required]="true"></input-state-autocomplete>

												<input-zipcode-autocomplete class="col-lg-4" [id]="'ZIP code'"
													[name]="'ZIP code'" [label]="'ZIP code'" [placeholder]="'ZIP code'"
													[(selectedZipcode)]="zipcode" [required]="true" [countryId]="1">
												</input-zipcode-autocomplete>
											</div>
											<div class="row">
												<mat-form-field class="col-lg-8">
													<mat-label>
														Work Phone Number
													</mat-label>
													<input matInput type="string" placeholder="workPhoneNumber"
														formControlName="workPhoneNumber" telephoneValidator />
												</mat-form-field>

												<mat-form-field class="col-lg-4">
													<mat-label>Ext</mat-label>
													<input matInput type="string" placeholder="Ext"
														formControlName="ext" [numericOnly]="10" />
												</mat-form-field>
											</div>
										</form>

										<hr />

										<div class="row">
											<div class="col-lg-12">
												<mat-checkbox [color]="'primary'" class="checkbox-margin"
													[(ngModel)]="nonMepApplicant"
													(ngModelChange)="toggleNonMepApplication()">
													Non-MEP Applicants</mat-checkbox>
											</div>
										</div>

										<section *ngIf="!nonMepApplicant">

											<div class="row">
												<div class="col">
													<region-dropdown-two-way class="col-lg-12" [isMultiple]="false"
														[(selectedRegion)]="region" [required]="true"
														[allowAllRegions]="true" [required]="true">
													</region-dropdown-two-way>
												</div>
											</div>
											<div class="row">
												<div class="col">
													<input-organization-autocomplete class="col-lg-12"
														[id]="'Organization'" [name]="'Organization'"
														[label]="'Organization that belongs to the chosen region (Optional)'"
														[placeholder]="'Search Organization'"
														[(selectedOrganization)]="selectedMepOrganization"
														[(region)]="region" [required]="false"
														[additionalErrorMsg]="'To skip this field, click Next.'">
													</input-organization-autocomplete>
												</div>
											</div>
										</section>

										<section *ngIf="nonMepApplicant">

											<div class="row">
												<div class="col">
													<input-organization-autocomplete class="col-lg-12"
														[id]="'Organization'" [name]="'Organization'"
														[label]="'Organization that belongs to the chosen region'"
														[placeholder]="'Search Organization'"
														[(selectedOrganization)]="selectedNonMepOrganization"
														[(region)]="region" [searchCategory]="'No Region'"
														[required]="true">
													</input-organization-autocomplete>
												</div>
											</div>

											<hr />

											<form [formGroup]="supervisorForm">
												<div class="row">
													<mat-form-field class="col-lg-4">
														<mat-label>
															Supervisor First Name
														</mat-label>
														<input matInput type="string"
															placeholder="Supervisor First Name"
															formControlName="supervisorFirstName" />
													</mat-form-field>

													<mat-form-field class="col-lg-4">
														<mat-label>
															Supervisor Last Name
														</mat-label>
														<input matInput type="string" placeholder="Supervisor Last Name"
															formControlName="supervisorLastName" />
													</mat-form-field>

													<mat-form-field class="col-lg-4">
														<mat-label>
															Supervisor Work Title
														</mat-label>
														<input matInput type="string"
															placeholder="Supervisor Work Title"
															formControlName="supervisorWorkTitle" />
													</mat-form-field>
												</div>

												<div class="row">
													<mat-form-field class="col-lg-4">
														<mat-label>
															Supervisor Email
														</mat-label>
														<input matInput type="email" placeholder="Supervisor Email"
															formControlName="supervisorEmail" />
													</mat-form-field>

													<mat-form-field class="col-lg-4">
														<mat-label>
															Supervisor Phone Number
														</mat-label>
														<input matInput type="string"
															placeholder="Supervisor Phone Number"
															formControlName="supervisorPhoneNumber"
															telephoneValidator />
													</mat-form-field>

													<mat-form-field class="col-lg-4">
														<mat-label>
															Ext
														</mat-label>
														<input matInput type="string" placeholder="Ext"
															formControlName="supervisorExt" [numericOnly]="10" />
													</mat-form-field>
												</div>
											</form>
										</section>

										<div class="row">
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button matStepperPrevious>
														Back
													</button>
												</mat-card>
											</div>
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button (click)="goNextLocation(stepper)"
														color="primary" [disabled]="!checkLocationValid()">
														Next
													</button>
												</mat-card>
											</div>
										</div>
									</mat-step>

									<mat-step>
										<ng-template matStepLabel>
											Rules of Behavior
										</ng-template>

										<div class="row">
											<div class="col-lg-12">
												<div>
													<strong>
														The information system Rules of Behavior (RoB) provides the
														rules that govern the appropriate use of the information system
														for all users. The RoB is intended to enhance and further define
														the specific rules each user must follow while accessing the
														information system and enforcing user understanding
													</strong>
												</div>
											</div>
										</div>
										<div class="row">
											<rules-of-behavior class="col-lg-12" class="rob-scroll" [readOnly]="true">
											</rules-of-behavior>
										</div>


										<div class="row">
											<sign-pad [(signatureString)]="signatureString" [required]="true">
											</sign-pad>
										</div>

										<div class="row">
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button matStepperPrevious>
														Back
													</button>
												</mat-card>
											</div>
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button (click)="goNextRulesOfBehavior(stepper)"
														color="primary" [disabled]="!checkRulesOfBehaviorValid()">
														Next
													</button>
												</mat-card>
											</div>
										</div>
									</mat-step>

									<mat-step>
										<ng-template matStepLabel>
											Submit
										</ng-template>

										<section>
											<h3 class="list-section">
												<strong>Personal Information</strong>
											</h3>
											<span class="list-section">
												<ul>
													<li>
														<strong>First Name:</strong>
														{{personalInfoForm.controls['firstName'].value}}
													</li>
													<li>
														<strong>Middle Initial:</strong>
														{{personalInfoForm.controls['middleInitial'].value}}
													</li>
													<li>
														<strong>Last Name:</strong>
														{{personalInfoForm.controls['lastName'].value}}
													</li>
													<li>
														<strong>Suffix:</strong>
														{{personalInfoForm.controls['suffix'].value}}
													</li>
													<li>
														<strong>Work Title:</strong>
														{{personalInfoForm.controls['workTitle'].value}}
													</li>
													<li>
														<strong>Work Email:</strong>
														{{personalInfoForm.controls['workEmail'].value}}
													</li>
												</ul>
											</span>
										</section>

										<section>
											<h3 class="list-section">
												<strong>Location Information</strong>
											</h3>
											<span class="list-section">
												<ul>
													<li>
														<strong>Work Address 1:</strong>
														{{locationForm.controls['workAddress1'].value}}
													</li>
													<li>
														<strong>Work Address 2:</strong>
														{{locationForm.controls['workAddress2'].value}}
													</li>
													<li>
														<strong>City:</strong>
														{{city.ID ? city.CITY_NAME : ''}}
													</li>
													<li>
														<strong>State:</strong>
														{{state.ID ? state.STATE_NAME : ''}}
													</li>
													<li>
														<strong>ZIP code:</strong>
														{{zipcode.ID ? zipcode.POSTAL_CODE : ''}}
													</li>
													<li>
														<strong>Work Phone:</strong>
														{{locationForm.controls['workPhoneNumber'].value}}
														{{locationForm.controls['ext'].value ? 'Ext: ' +
														locationForm.controls['ext'].value : ''}}
													</li>
													<hr />
													<li *ngIf="!nonMepApplicant">
														<strong>Region:</strong>
														{{region?.NAME}} {{region?.CODE ? '(' + region?.CODE + ')' :
														''}}
													</li>
													<!-- <li *ngIf="!nonMepApplicant">
														<strong>School Districts:</strong>
														To be added
													</li> -->
													<li *ngIf="!nonMepApplicant">
														<strong>Organization:</strong>
														{{selectedMepOrganization.ID ? selectedMepOrganization.NAME :
														'---'}}
													</li>
													<li *ngIf="nonMepApplicant">
														<strong><u>Non-MEP Applicant</u></strong>
														<ul>
															<li>
																<strong>Organization:</strong>
																{{selectedNonMepOrganization.NAME}}
															</li>
															<li>
																<strong>Supervisor First Name:</strong>
																{{supervisorForm.controls['supervisorFirstName'].value}}
															</li>
															<li>
																<strong>Supervisor Last Name:</strong>
																{{supervisorForm.controls['supervisorLastName'].value}}
															</li>
															<li>
																<strong>Supervisor Work Title:</strong>
																{{supervisorForm.controls['supervisorWorkTitle'].value}}
															</li>
															<li>
																<strong>Supervisor Email:</strong>
																{{supervisorForm.controls['supervisorEmail'].value}}
															</li>
															<li>
																<strong>Supervisor Phone:</strong>
																{{supervisorForm.controls['supervisorPhoneNumber'].value}}
																{{supervisorForm.controls['supervisorExt'].value ?
																'Ext:'
																+
																supervisorForm.controls['supervisorExt'].value : ''}}
															</li>
														</ul>
													</li>
												</ul>
											</span>
											<span *ngIf="nonMepApplicant">

											</span>
										</section>

										<section>
											<h3 class="list-section">
												<strong>Rules of Behavior</strong>
											</h3>
											<span class="list-section">
												<ul>
													<li>
														<strong>Your Signature</strong>
													</li>
													<li>

														<img alt="Your Signature" class="cursor-pointer"
															*ngIf="signatureString.length > 0"
															[src]="signatureString" />
													</li>
												</ul>
											</span>
										</section>

										<div class="row">
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button matStepperPrevious (click)="clearMsg()">
														Back
													</button>
												</mat-card>
											</div>
											<div class="col-lg-6">
												<mat-card>
													<button mat-raised-button color="primary" (click)="submit()"
														[disabled]="!checkValid() || isLoading">
														<mat-icon *ngIf="isLoading">
															<mat-spinner diameter="20"></mat-spinner>
														</mat-icon>
														Submit
													</button>
												</mat-card>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-12">
												<app-msg [msg]="msg"></app-msg>
											</div>
										</div>
									</mat-step>
								</mat-stepper>
							</mat-card-content>
						</div>
					</mat-card>
				</div>
				<div class="col-lg-3">
					<mat-card appearance="outlined">
						<div>
							<mat-card-content>
								<p>
									<strong>Need help?</strong>
									<br />
									Contact the MSIN Service Desk:
									<a href="tel:1-800-342-2964">800-342-2964</a>, or email
									<a href="mailto:msinsupport@wested.org">
										msinsupport&#64;wested.org
									</a>
									.
								</p>
							</mat-card-content>
							<hr />
							<mat-card-content>
								<p>
									<strong>Already requested an account?</strong>
									<br />
									If you have not received an email asking you to
									confirm your email address after submitting your
									account request, please click
									<a routerLink="/account-request/resend-confirmation-code">
										here
									</a>
									.
								</p>
							</mat-card-content>
							<mat-card class="margin-top-sm">
								<a mat-raised-button routerLink="/login">Back to Login</a>
							</mat-card>
						</div>
					</mat-card>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>